import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
  {
    description: 'Atividades',
    path: '/calendario/atividades',
    name: 'calatividade',
    component: () => import('@/views/calendario/atividade/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.ATIVIDADESNOVO_MENU_200200199],
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Atividades',
    path: '/calendario/atividades/cadastro/:id?',
    parent: 'calatividade',
    name: 'calatividade_create',
    component: () => import('@/views/calendario/atividade/components/InclusaoEdicao.vue'),
    meta: {
      permissions: [eTipoPermissao.ATIVIDADESNOVO_MENU_200200199],
    },
    goesToMenu: true,
  },
];
